import { negate, isNil } from 'lodash-es';
import { PurchaseInfo } from 'services';

export function formatPurchaseInfo(purchaseInfo: PurchaseInfo, sign: string) {
  return [purchaseInfo.Price, sign].filter(negate(isNil)).join('');
}

export enum ServiceMessage {
  Blocked = 'Blocked'
}
